import { z } from "zod";

export const concatenateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  spacer: z.string(),
  addToCollection: z.boolean(),
});

export type ConcatenateFormData = z.infer<typeof concatenateSchema>;
